import Beside from "@modules/layout/components/beside-menu";
import PageHeader from "@modules/layout/components/page-header";
import { HeaderData } from "@data/menu";
import { PartsData } from "@data/parts";

import { useTranslations } from "next-intl";
import types, { GetServerSideProps, InferGetServerSidePropsType } from "next";
import { ServiceData } from "@/data/service";
import { Technology } from "@/data/technology";
import Markdown from "react-markdown";
import { useRouter } from "next/router";
import Head from "@/modules/common/components/head";
import Footer from "@/modules/layout/templates/footer";
import Nav from "@/modules/layout/templates/nav";

const Parts: InferGetServerSidePropsType<typeof getServerSideProps> = (props: any) => {
  const t = useTranslations("Menu");
  const data = props.data;
  const { locale, locales, route, asPath } = useRouter();
  return (
    <>
      <Head title={data}></Head>
      <Nav />
      <PageHeader
        title={data}
        sub={{ title: "Repair option", handle: "/en/service/repair" }}
        image="https://d3leeb4r1qy96s.cloudfront.net/assets/img/cta-banner-image-1536x306.jpg"
      />
      <article className="page-body container page type-page status-publish hentry" id="page-body">
        <div className="row">
          <main className="page-content col-md-9 col-md-push-3">
            <div className="container  py-5 text-center">
              <h1 className="mb-8">UPDATING</h1>
              <a href="/en/service/repair" className="btn btn-primary">
                Return
              </a>
            </div>
          </main>
          <Beside menu={ServiceData} title={t(`service`)} translate="Menu" />
        </div>
      </article>
      <Footer />
    </>
  );
};

export default Parts;

export const getServerSideProps: GetServerSideProps = async (context) => {
  const link = context?.params?.link;
  return {
    props: {
      data: link,
      messages: (await import(`../../../../../messages/${context.locale}.json`)).default,
    },
  };
};
